/* eslint-disable react/display-name */
/* eslint-disable camelcase */
/* eslint-disable comma-dangle */

import React from 'react';
import dynamic from 'next/dynamic';
import Highlight from 'react-scale/components/ui/highlight';
import ExampleLoading from '../ExampleLoading';

const TaskResponseCuboidAnnotation = dynamic(
  () => import('../tasks/TaskResponseImageCuboidAnnotation'),
  {
    loading: () => <ExampleLoading />,
    ssr: false
  }
);

export const realResponse = {
  annotations: [
    {
      label: 'building',
      vertices: [
        {
          type: 'vertex',
          x: 449.9166666666667,
          y: 242.91666666666666,
          description: 'face-topleft'
        },
        {
          type: 'vertex',
          x: 449.9166666666667,
          y: 568.25,
          description: 'face-bottomleft'
        },
        {
          type: 'vertex',
          x: 534.25,
          y: 242.91666666666666,
          description: 'face-topright'
        },
        {
          type: 'vertex',
          x: 534.25,
          y: 568.25,
          description: 'face-bottomright'
        },
        {
          type: 'vertex',
          x: 412.9166666666667,
          y: 258.91666666666663,
          description: 'side-topcorner'
        },
        {
          type: 'vertex',
          x: 412.9166666666667,
          y: 534.25,
          description: 'side-bottomcorner'
        }
      ],
      edges: [
        {
          type: 'edge',
          x1: 449.9166666666667,
          y1: 242.91666666666666,
          x2: 534.25,
          y2: 242.91666666666666,
          description: 'face-top'
        },
        {
          type: 'edge',
          x1: 534.25,
          y1: 242.91666666666666,
          x2: 534.25,
          y2: 568.25,
          description: 'face-right'
        },
        {
          type: 'edge',
          x1: 534.25,
          y1: 568.25,
          x2: 449.9166666666667,
          y2: 568.25,
          description: 'face-bottom'
        },
        {
          type: 'edge',
          x1: 449.9166666666667,
          y1: 568.25,
          x2: 449.9166666666667,
          y2: 242.91666666666666,
          description: 'face-left'
        },
        {
          type: 'edge',
          x1: 449.9166666666667,
          y1: 242.91666666666666,
          x2: 412.9166666666667,
          y2: 258.91666666666663,
          description: 'side-top'
        },
        {
          type: 'edge',
          x1: 412.9166666666667,
          y1: 258.91666666666663,
          x2: 412.9166666666667,
          y2: 534.25,
          description: 'side-back'
        },
        {
          type: 'edge',
          x1: 412.9166666666667,
          y1: 534.25,
          x2: 449.9166666666667,
          y2: 568.25,
          description: 'side-bottom'
        }
      ]
    },
    {
      label: 'building',
      vertices: [
        {
          type: 'vertex',
          x: 697.25,
          y: 378.9166666666667,
          description: 'face-topleft'
        },
        {
          type: 'vertex',
          x: 697.25,
          y: 654.5833333333334,
          description: 'face-bottomleft'
        },
        {
          type: 'vertex',
          x: 850.9166666666666,
          y: 378.9166666666667,
          description: 'face-topright'
        },
        {
          type: 'vertex',
          x: 850.9166666666666,
          y: 654.5833333333334,
          description: 'face-bottomright'
        },
        {
          type: 'vertex',
          x: 638.25,
          y: 375.9166666666667,
          description: 'side-topcorner'
        },
        {
          type: 'vertex',
          x: 638.25,
          y: 631.5833333333334,
          description: 'side-bottomcorner'
        }
      ],
      edges: [
        {
          type: 'edge',
          x1: 697.25,
          y1: 378.9166666666667,
          x2: 850.9166666666666,
          y2: 378.9166666666667,
          description: 'face-top'
        },
        {
          type: 'edge',
          x1: 850.9166666666666,
          y1: 378.9166666666667,
          x2: 850.9166666666666,
          y2: 654.5833333333334,
          description: 'face-right'
        },
        {
          type: 'edge',
          x1: 850.9166666666666,
          y1: 654.5833333333334,
          x2: 697.25,
          y2: 654.5833333333334,
          description: 'face-bottom'
        },
        {
          type: 'edge',
          x1: 697.25,
          y1: 654.5833333333334,
          x2: 697.25,
          y2: 378.9166666666667,
          description: 'face-left'
        },
        {
          type: 'edge',
          x1: 697.25,
          y1: 378.9166666666667,
          x2: 638.25,
          y2: 375.9166666666667,
          description: 'side-top'
        },
        {
          type: 'edge',
          x1: 638.25,
          y1: 375.9166666666667,
          x2: 638.25,
          y2: 631.5833333333334,
          description: 'side-back'
        },
        {
          type: 'edge',
          x1: 638.25,
          y1: 631.5833333333334,
          x2: 697.25,
          y2: 654.5833333333334,
          description: 'side-bottom'
        }
      ]
    },
    {
      label: 'tower',
      vertices: [
        {
          type: 'vertex',
          x: 585.4722222222222,
          y: 161.91666666666666,
          description: 'face-topleft'
        },
        {
          type: 'vertex',
          x: 585.4722222222222,
          y: 384.1388888888889,
          description: 'face-bottomleft'
        },
        {
          type: 'vertex',
          x: 615.4722222222222,
          y: 161.91666666666666,
          description: 'face-topright'
        },
        {
          type: 'vertex',
          x: 615.4722222222222,
          y: 384.1388888888889,
          description: 'face-bottomright'
        },
        {
          type: 'vertex',
          x: 557.4722222222222,
          y: 164.91666666666666,
          description: 'side-topcorner'
        },
        {
          type: 'vertex',
          x: 557.4722222222222,
          y: 385.1388888888889,
          description: 'side-bottomcorner'
        }
      ],
      edges: [
        {
          type: 'edge',
          x1: 585.4722222222222,
          y1: 161.91666666666666,
          x2: 615.4722222222222,
          y2: 161.91666666666666,
          description: 'face-top'
        },
        {
          type: 'edge',
          x1: 615.4722222222222,
          y1: 161.91666666666666,
          x2: 615.4722222222222,
          y2: 384.1388888888889,
          description: 'face-right'
        },
        {
          type: 'edge',
          x1: 615.4722222222222,
          y1: 384.1388888888889,
          x2: 585.4722222222222,
          y2: 384.1388888888889,
          description: 'face-bottom'
        },
        {
          type: 'edge',
          x1: 585.4722222222222,
          y1: 384.1388888888889,
          x2: 585.4722222222222,
          y2: 161.91666666666666,
          description: 'face-left'
        },
        {
          type: 'edge',
          x1: 585.4722222222222,
          y1: 161.91666666666666,
          x2: 557.4722222222222,
          y2: 164.91666666666666,
          description: 'side-top'
        },
        {
          type: 'edge',
          x1: 557.4722222222222,
          y1: 164.91666666666666,
          x2: 557.4722222222222,
          y2: 385.1388888888889,
          description: 'side-back'
        },
        {
          type: 'edge',
          x1: 557.4722222222222,
          y1: 385.1388888888889,
          x2: 585.4722222222222,
          y2: 384.1388888888889,
          description: 'side-bottom'
        }
      ]
    },
    {
      label: 'tower',
      vertices: [
        {
          type: 'vertex',
          x: 810.9166666666666,
          y: 34.25,
          description: 'face-topleft'
        },
        {
          type: 'vertex',
          x: 810.9166666666666,
          y: 570.9166666666666,
          description: 'face-bottomleft'
        },
        {
          type: 'vertex',
          x: 919.25,
          y: 34.25,
          description: 'face-topright'
        },
        {
          type: 'vertex',
          x: 919.25,
          y: 570.9166666666666,
          description: 'face-bottomright'
        },
        {
          type: 'vertex',
          x: 733.9166666666666,
          y: 47.25,
          description: 'side-topcorner'
        },
        {
          type: 'vertex',
          x: 733.9166666666666,
          y: 563.9166666666666,
          description: 'side-bottomcorner'
        }
      ],
      edges: [
        {
          type: 'edge',
          x1: 810.9166666666666,
          y1: 34.25,
          x2: 919.25,
          y2: 34.25,
          description: 'face-top'
        },
        {
          type: 'edge',
          x1: 919.25,
          y1: 34.25,
          x2: 919.25,
          y2: 570.9166666666666,
          description: 'face-right'
        },
        {
          type: 'edge',
          x1: 919.25,
          y1: 570.9166666666666,
          x2: 810.9166666666666,
          y2: 570.9166666666666,
          description: 'face-bottom'
        },
        {
          type: 'edge',
          x1: 810.9166666666666,
          y1: 570.9166666666666,
          x2: 810.9166666666666,
          y2: 34.25,
          description: 'face-left'
        },
        {
          type: 'edge',
          x1: 810.9166666666666,
          y1: 34.25,
          x2: 733.9166666666666,
          y2: 47.25,
          description: 'side-top'
        },
        {
          type: 'edge',
          x1: 733.9166666666666,
          y1: 47.25,
          x2: 733.9166666666666,
          y2: 563.9166666666666,
          description: 'side-back'
        },
        {
          type: 'edge',
          x1: 733.9166666666666,
          y1: 563.9166666666666,
          x2: 810.9166666666666,
          y2: 570.9166666666666,
          description: 'side-bottom'
        }
      ]
    },
    {
      label: 'building',
      vertices: [
        {
          type: 'vertex',
          x: 569.25,
          y: 379.45,
          description: 'face-topleft'
        },
        {
          type: 'vertex',
          x: 569.25,
          y: 569.85,
          description: 'face-bottomleft'
        },
        {
          type: 'vertex',
          x: 617.25,
          y: 379.45,
          description: 'face-topright'
        },
        {
          type: 'vertex',
          x: 617.25,
          y: 569.85,
          description: 'face-bottomright'
        },
        {
          type: 'vertex',
          x: 638.25,
          y: 377.45,
          description: 'side-topcorner'
        },
        {
          type: 'vertex',
          x: 638.25,
          y: 563.85,
          description: 'side-bottomcorner'
        }
      ],
      edges: [
        {
          type: 'edge',
          x1: 569.25,
          y1: 379.45,
          x2: 617.25,
          y2: 379.45,
          description: 'face-top'
        },
        {
          type: 'edge',
          x1: 617.25,
          y1: 379.45,
          x2: 617.25,
          y2: 569.85,
          description: 'face-right'
        },
        {
          type: 'edge',
          x1: 617.25,
          y1: 569.85,
          x2: 569.25,
          y2: 569.85,
          description: 'face-bottom'
        },
        {
          type: 'edge',
          x1: 569.25,
          y1: 569.85,
          x2: 569.25,
          y2: 379.45,
          description: 'face-left'
        },
        {
          type: 'edge',
          x1: 617.25,
          y1: 379.45,
          x2: 638.25,
          y2: 377.45,
          description: 'side-top'
        },
        {
          type: 'edge',
          x1: 638.25,
          y1: 377.45,
          x2: 638.25,
          y2: 563.85,
          description: 'side-back'
        },
        {
          type: 'edge',
          x1: 638.25,
          y1: 563.85,
          x2: 617.25,
          y2: 569.85,
          description: 'side-bottom'
        }
      ]
    }
  ]
};

export const instruction = 'Draw a cuboid around each building or tower.';

export const responseCode = `{
  "annotations": [
    {
      "label": "building",
      "vertices": [
        {
          "type": "vertex",
          "x": 482.25,
          "y": 244.25,
          "description": "face-topleft"
        },
        {
          "type": "vertex",
          "x": 482.25,
          "y": 399.25,
          "description": "face-bottomleft"
        },
        {
          "type": "vertex",
          "x": 636.25,
          "y": 244.25,
          "description": "face-topright"
        }
      ],
      "edges": [
        {
          "description": "face-left",
          "y2": 270,
          "x2": 471,
          "y1": 270,
          "x1": 293,
          "type": "edge"
        },
        {
          "description": "face-top",
          "y2": 437,
          "x2": 471,
          "y1": 270,
          "x1": 471,
          "type": "edge"
        },
        {
          "description": "face-bottom",
          "y2": 437,
          "x2": 293,
          "y1": 437,
          "x1": 471,
          "type": "edge"
        },
        {
          "description": "face-right",
          "y2": 270,
          "x2": 293,
          "y1": 437,
          "x1": 293,
          "type": "edge"
        },
        {
          "description": "side-top",
          "y2": 286,
          "x2": 607,
          "y1": 270,
          "x1": 471,
          "type": "edge"
        },
        {
          "description": "side-back",
          "y2": 373,
          "x2": 607,
          "y1": 286,
          "x1": 607,
          "type": "edge"
        },
        {
          "description": "side-bottom",
          "y2": 437,
          "x2": 471,
          "y1": 373,
          "x1": 607,
          "type": "edge"
        }
      ]
    }
  ]
}`;

export const code = `client.createCuboidannotationTask({
  callback_url: 'http://www.example.com/callback',
  instruction: '${instruction}',
  attachment_type: 'image',
  attachment: 'http://i.imgur.com/v4cBreD.jpg',
  objects_to_annotate: ['building', 'tower']
}, (err, task) => {
    // do something with task
});`;

export const response = (
  <div className="data-collection">
    <Highlight className="javascript" key="highlight-json">
      {responseCode}
    </Highlight>
  </div>
);

export const example = () => (
  <TaskResponseCuboidAnnotation
    annotations={[]}
    imageURL="/static/img/examples/3d-cuboids-drones.png"
    rounded
  />
);
export const result = (
  <TaskResponseCuboidAnnotation
    annotations={realResponse.annotations}
    imageURL="/static/img/examples/3d-cuboids-drones.png"
    rounded
  />
);
